document.addEventListener("DOMContentLoaded", () => {
  const initSlider = () => {
    $(".slider")
      .slick({
        speed: 300,
        infinite: true,
        slidesToShow:2,
        slidesToScroll: 2,
        prevArrow: $(".arrows-best-sellers .icons-left svg"),
        nextArrow: $(".arrows-best-sellers .icons-right svg"),
        responsive: [
          {
            breakpoint: 768,
             settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          },
        ],
      });
  };
  initSlider();
  window.addEventListener("resize", initSlider);
});